import { api } from './api'

// Comments and guides the signed-in user can open, for items that cover `page`
// of `standard`. Empty lists mean the page has nothing to mark.
export function listPageMarks(standard, page) {
  const query = `?standard=${encodeURIComponent(standard)}&page=${encodeURIComponent(page)}`
  return api.get(`/comments/on-page${query}`)
}
